module.exports = __webpack_public_path__ + "media/images/Washington-0f952b5720799d56dccba5c83258cca3.jpg";